// removed by extract-text-webpack-plugin
module.exports = {"container":"_2TVUlFSVxflCq2CBZFUDaG","fade-in":"FLSsFaLwP4TFM83cq398L","contentContainer":"tj7w0xTvQYdekwKsHLL6o"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Results/styles.css
// module id = 406
// module chunks = 0